import * as Headless from '@headlessui/react';
import clsx from 'clsx';
import { useMemo, useState } from 'react';

export default function SearchableListbox({
  options = [],
  value,
  onChange,
  placeholder = 'Selecciona...',
  searchPlaceholder = 'Buscar...',
  className,
  'aria-label': ariaLabel,
  popupClassName,
}) {
  const [query, setQuery] = useState('');

  // Options may carry, beside `label`, a `description` (second line, muted),
  // a `meta` (small text at the right of the first line) and a `resumen`
  // (what the closed button shows instead of the label). The search covers
  // all of them.
  const filtered = useMemo(() => {
    if (!query) return options;
    const q = query.toLowerCase();
    return options.filter((opt) =>
      `${opt.label || ''} ${opt.description || ''} ${opt.meta || ''}`.toLowerCase().includes(q)
    );
  }, [options, query]);
  const seleccionada = options.find((opt) => opt.value === value);

  return (
    <Headless.Listbox value={value} onChange={onChange}>
      <div className={clsx('relative', className)}>
        <Headless.ListboxButton className="relative block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-left text-sm font-medium text-zinc-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-azul-surelia/50">
          <span className="block truncate">
            {seleccionada ? (seleccionada.resumen || seleccionada.label) : placeholder}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <svg className="h-4 w-4 text-zinc-500" viewBox="0 0 20 20" fill="none">
              <path d="M7 7l3-3 3 3m0 6l-3 3-3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </Headless.ListboxButton>

        <Headless.ListboxOptions
          portal={false}
          className={clsx(
            "absolute left-0 z-50 mt-1 max-h-80 overflow-auto rounded-lg bg-white shadow-lg ring-1 ring-black/5 focus:outline-none",
            popupClassName
          )}
        >
          <div className="sticky top-0 z-10 bg-white p-2 border-b border-zinc-200">
            <input
              aria-label={ariaLabel || 'Buscar'}
              className="w-full rounded-md border border-zinc-200 px-2 py-1 text-sm focus:border-azul-surelia focus:outline-none focus:ring-1 focus:ring-azul-surelia"
              placeholder={searchPlaceholder}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
          {filtered.length === 0 && (
            <div className="px-3 py-2 text-sm text-zinc-500">No se encontraron resultados</div>
          )}
          {filtered.map((opt) => (
            <Headless.ListboxOption
              key={opt.value}
              value={opt.value}
              as="div"
              className={({ active, selected }) =>
                clsx(
                  'cursor-pointer select-none px-3 py-2 text-sm',
                  active ? 'bg-azul-surelia/10 text-azul-surelia' : 'text-zinc-800',
                  selected && 'font-semibold'
                )
              }
            >
              {opt.description || opt.meta ? (
                <div className="min-w-0">
                  <div className="flex items-baseline justify-between gap-3">
                    <span className="truncate">{opt.label}</span>
                    {opt.meta && (
                      <span className="flex-shrink-0 text-[11px] font-normal text-zinc-400 tabular-nums">{opt.meta}</span>
                    )}
                  </div>
                  {opt.description && (
                    <div className="truncate text-xs font-normal text-zinc-500">{opt.description}</div>
                  )}
                </div>
              ) : opt.label}
            </Headless.ListboxOption>
          ))}
        </Headless.ListboxOptions>
      </div>
    </Headless.Listbox>
  );
}
